module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av166-cc247ac740f7ce145de579e555fb58cc.jpg";